import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

// The shared DatePicker works in DD/MM/YYYY strings; the server takes
// YYYY-MM-DD and returns an ISO timestamp.
const PICKER_FORMAT = 'DD/MM/YYYY';

export const todayForPicker = () => dayjs().format(PICKER_FORMAT);

/** An ISO date from the server → the picker's DD/MM/YYYY ('' when absent). */
export const toPickerDate = (value) => (value ? dayjs(value).format(PICKER_FORMAT) : '');

/** The picker's DD/MM/YYYY → YYYY-MM-DD for the server ('' when empty or invalid). */
export const toServerDate = (value) => {
  const date = value ? dayjs(value, PICKER_FORMAT, true) : null;
  return date?.isValid() ? date.format('YYYY-MM-DD') : '';
};
